import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { bundleKeys } from "./bundle-keys";

export function useDeleteBundle() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (code: string) => {
      const { error } = await apiClient.DELETE("/v1/listings/{code}", {
        params: { path: { code } },
      });
      if (error) throw error;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: bundleKeys.all });
    },
  });
}
